import Vue from 'vue';
import Store from '../../lib/stores/store';
import Instance from './instance.html';
import EcMultiSelectGroup from '../../lib/components/multiSelectGroup/multiSelectGroup';
import MemberSearch from './memberSearch';
import MemberSearchChiclets from './memberSearchChiclets';
import MemberSearchResults from './memberSearchResults';
import EcSpinner from '../../lib/components/spinner/spinner';
import Error from '../../lib/components/error/error';

if (document.getElementById('ecMemberSearch')) {
	const vue = new Vue({
		el: '#ecMemberSearch',
		store: Store,
		template: Instance,
		components: {
			EcMultiSelectGroup,
			EcSpinner,
			Error,
			MemberSearch,
			MemberSearchChiclets,
			MemberSearchResults,
		},
	});
}
